const init = () => {

  // Enable video block functionality if cookiebot data attribute is not found
  // Note: The data-cbid is included in the script tag in the header when implementing Cookiebot
  if (!$('[data-cbid]').length) {
    $('.cookie-message').remove();

    if ($('.video-block__container').length) {

      let source = $('.video-block__container iframe');

      $(source).each(function () {
        $(this).attr({
          src: $(this).attr('data-src')
        });
      });
    };
  }

  // When at least one other checkbox other than the "Necessary" checkbox is checked and "OK" is clicked
  window.addEventListener('CookiebotOnAccept', function () {

    // data tracking
    if (Cookiebot.consent.preferences) {
      dataLayer.push({
        'event': 'cookieconsent_preferences',
        'preferencesStatus': 'true'
      });
    }

    if (Cookiebot.consent.statistics) {
      dataLayer.push({
        'event': 'cookieconsent_statistics',
        'statisticsStatus': 'true'
      });
    }

    if (Cookiebot.consent.marketing) {
      // enable fitvid on youtube embed video
      setTimeout(function () {
        $('.js-responsive-video').fitVids();
      }, 2000);

      dataLayer.push({
        'event': 'cookieconsent_marketing',
        'marketingStatus': 'true'
      });
    }

  }, false);

  // Everything unticked apart from 'Necessary'
  window.addEventListener('CookiebotOnDecline', function () {
    dataLayer.push({
      'event': 'cookieconsent_declineAll',
      'preferencesStatus': 'false',
      'statisticsStatus': 'false',
      'marketingStatus': 'false'
    });
  }, false);

};

export {
  init
}